exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".results-table[data-v-b650f740]{overflow-x:auto;width:100%}.results-table.header-only[data-v-b650f740]{margin-bottom:0;overflow-y:hidden}.results-table.header-only thead[data-v-b650f740]{position:sticky;top:0;z-index:1}.results-table.content-only thead[data-v-b650f740],.results-table.header-only tbody[data-v-b650f740]{visibility:collapse;line-height:0}.width-126[data-v-b650f740]{width:126px;min-width:126px}.column-width[data-v-b650f740]{width:280px;min-width:280px}", ""]);

// exports
